import { fileStatisticsModalQueryFunction } from '@/modules/Dashboard/queries/fileStatisticsModalQuery/fileStatisticsModalQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const useFileStatisticsModalQueryOptions = queryOptions({
  queryKey: ['file-statistics-modal'],
  queryFn: fileStatisticsModalQueryFunction,
});
